export default "__VITE_ASSET__B264eRm$__"